import { useMemo } from "react";
import {
  ResponseError,
  WorkLogList,
  WorkLogsApiListWorkLogsRequest
} from "@wingspanhq/wingspan-api-sdk";
import { WSQueryConfig } from "@ws-react-query";
import { queriesWorkLogs } from "@query";

export type IWorkLogsSummary = {
  listSize: number;
  totalAmount: number;
};

/**
 * v3 work-log summary. v1 read the totals off response headers
 * (`x-ws-list-size` / `x-ws-custom-worklog-amount-total`); v3 now exposes both on
 * the `listWorkLogs` response itself — `listSize` from `pagination.totalSize` and
 * the amount total from `metadata.totalAmount`. Both are full-set aggregates over
 * the filtered collection, independent of the page requested, so a single one-row
 * page carries them — no more walking every page (`useQueryAll`) to sum client-side.
 */
export const useQueryWorkLogsSummary = (
  params?: WorkLogsApiListWorkLogsRequest,
  config?: WSQueryConfig<WorkLogList, ResponseError>
) => {
  const query = queriesWorkLogs.listWorkLogs.useQuery(
    { ...params, page: { size: 1 } },
    config
  );

  const data = useMemo<IWorkLogsSummary>(
    () => ({
      listSize: query.data?.pagination?.totalSize ?? 0,
      totalAmount: query.data?.metadata?.totalAmount ?? 0
    }),
    [query.data]
  );

  return { ...query, data };
};
